import {Text, TouchableOpacity, View} from 'react-native';
import React from 'react';
import strings from '../../../translations';
import styleSheet from './styles';
import {useTheme} from 'contexts/ThemeContext';

export interface GetRecordingButtonProps {
  onGetRecordingButtonPressed(): void;
  buttonStyle?: object;
  textButtonStyle?: object;
}

const GetRecordingButton = (props: GetRecordingButtonProps) => {
  const styles = styleSheet(useTheme());

  return (
    <TouchableOpacity
      activeOpacity={0.8}
      style={[styles.getRecordingButtonStyle, props.buttonStyle]}
      onPress={props.onGetRecordingButtonPressed}>
      <Text style={[styles.getRecordingText, props.textButtonStyle]}>
        {strings.conferenceScreen.classRecordRequest}
      </Text>
    </TouchableOpacity>
  );
};

export default GetRecordingButton;
